import React, { useContext } from "react";
import PropTypes from "prop-types";
import UserPrefsContext from "../../../context/UserPrefs/UserPrefsContext";

import Select from "../../shared/InputElements/Select";
import { useIntl } from "react-intl";

const SelectWifiConnectivity = ({ id = "select-wifi-connectivity", handler = () => {}, ...rest }) => {
     const intl = useIntl();
     const userPrefs = useContext(UserPrefsContext);
     const chargerWifi = userPrefs.get("chargerWifiFilter");

     const label = intl.formatMessage
          ? intl.formatMessage({ id: "wifiConnectivity", defaultMessage: "Wifi Connectivity" })
          : "Wifi Connectivity";

     const optionNames = [
          intl.formatMessage({ id: "yes", defaultMessage: "Yes" }),
          intl.formatMessage({ id: "no", defaultMessage: "No" }),
          intl.formatMessage({ id: "all", defaultMessage: "All" }),
     ];

     const optionValues = ["yes", "no", "all"];

     const currentValue = Object.entries(chargerWifi).find(([key, val]) => val)?.[0] || "all";

     const handleChange = (e) => {
          const selectedKey = e.target.value;
          const newFilters = {
               yes: false,
               no: false,
          };

          if (selectedKey !== "all") {
               newFilters[selectedKey] = true;
          }

          userPrefs.set({ chargerWifiFilter: newFilters });
          handler(selectedKey);
     };

     return (
          <Select
               id={id}
               value={currentValue}
               label={label}
               optionNames={optionNames}
               optionValues={optionValues}
               handler={handleChange}
               {...rest}
          />
     );
};

export default SelectWifiConnectivity;

SelectWifiConnectivity.propTypes = {
     id: PropTypes.string,
     label: PropTypes.string,
     handler: PropTypes.func,
};
